module.exports = __webpack_public_path__ + "img/envelope-simple-bold.12924ea1.svg";